// src/components/BottomNav.js
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaDumbbell,
  FaChartLine,
  FaUser,
  FaCalendarAlt,
} from "react-icons/fa";
import { useEffect } from "react";
import "./BottomNav.css";

const NAV_ITEMS = [
  { path: "/", label: "Home", icon: <FaHome /> },
  { path: "/workout", label: "Track", icon: <FaDumbbell /> },
  { path: "/plan", label: "Plan", icon: <FaCalendarAlt /> },
  { path: "/analytics", label: "Analytics", icon: <FaChartLine /> },
  { path: "/profile", label: "Profile", icon: <FaUser /> },
];

export default function BottomNav() {
  const location = useLocation();

  // Log whenever React Router thinks location changed
  useEffect(() => {
    console.log(
      "[ROUTER] location changed:",
      location.pathname,
      "| window.location:",
      window.location.pathname
    );
  }, [location.pathname]);

  return (
    <nav
      className="bottom-nav"
      onClickCapture={(e) => {
        console.log(
          "BOTTOM NAV CLICK",
          "| target:",
          e.target?.tagName,
          "| defaultPrevented:",
          e.defaultPrevented
        );
      }}
    >
      {NAV_ITEMS.map((item) => {
        const isActive = location.pathname === item.path;

        return (
          <Link
            key={item.path}
            to={item.path}
            onClick={(e) => {
            }}
            className={`bottom-nav-item ${isActive ? "active" : ""}`}
          >
            <div className="icon">{item.icon}</div>
            <span className="label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}